import { supabase } from "@/infrastructure/supabase/client";
import type { ReviewTicketRow } from "@/infrastructure/supabase/database.types";

/**
 * review_tickets — the outbound record of what /feature-review-sync sent (which
 * block-v board item + which Worktracker ticket a flow maps to). Read-only in the
 * app: the driver writes it with the service role; RLS grants the browser SELECT
 * only, so there is deliberately no create/update here. The surface that reads it is
 * the block-v card drawer (BoardReviewTicketSection) — there is no separate tab.
 */
export const reviewTicketsRepository = {
  /** The review ticket for a given block-v board item, by its BF code (or null). */
  async getByBoardCode(boardCode: string): Promise<ReviewTicketRow | null> {
    const { data, error } = await supabase
      .from("review_tickets")
      .select("*")
      .eq("board_code", boardCode)
      .maybeSingle();
    if (error) throw error;
    return (data as ReviewTicketRow | null) ?? null;
  },
};
